import React from 'react';

const LABELS = {
  awaiting_manual_login: 'awaiting login',
  manual_login_timeout:  'login timed out',
  auth_failed:           'auth failed',
  needs_attention:       'needs attention',
};

const PULSING = new Set(['starting', 'awaiting_manual_login', 'needs_attention']);

/**
 * Unified pill for container status, relationship status, copy execution, etc.
 * Falls back to a neutral grey pill for unknown values.
 */
export default function StatusPill({ status, label }) {
  const cls = `ct-pill is-${status || 'none'}`;
  const text = label || LABELS[status] || status || 'none';
  return (
    <span className={cls}>
      <span className={PULSING.has(status) ? 'dot ct-pulse' : 'dot'} />
      {text}
    </span>
  );
}
